const PHASES = [
  "Project Created",
  "Planning",
  "In Progress",
  "Project Completed",
];

const VALID_PHASES = new Set(PHASES);

function normalizePhase(v) {
  if (!v) return "Project Created";
  return VALID_PHASES.has(v) ? v : "Project Created";
}

function mapProjectTypeForBackend(uiValue) {
  switch (uiValue) {
    case "business_attraction":
      return "Attraction";
    case "business_retention_expansion":
      return "Expansion";
    case "startup":
      return "Startup";
    default:
      return uiValue || null;
  }
}

function mapApiTypeToUi(v) {
  const x = String(v || "")
    .toLowerCase()
    .trim();
  if (x === "attraction") return "business_attraction";
  if (x === "retention" || x === "expansion")
    return "business_retention_expansion";
  if (x === "startup") return "startup";
  return "";
}

function buildProjectPayload(project) {
  const normalizedType = mapProjectTypeForBackend(project.project_type);
  const infrastructureRequirements = Array.isArray(project.infrastructure_requirements)
    ? project.infrastructure_requirements
    : String(project.infrastructure_requirements || "")
      .split(",")
      .map((requirement) => requirement.trim())
      .filter(Boolean);

  return {
    project_name: project.project_name || null,
    company_id: project.company_id,
    company_source: project.company_source || "bre",
    company: project.company,
    city: project.city,
    country: project.country,
    state: project.state,
    sector: project.sector,
    industry: project.industry,
    naics_code: project.naics_code?.trim() || null,
    naics_text: project.naics_text?.trim() || null,
    industry_custom: project.industry_custom?.trim() || null,

    investment_amount:
      project.investment_amount !== ""
        ? parseFloat(project.investment_amount)
        : null,

    jobs_created:
      project.jobs_created !== "" ? parseInt(project.jobs_created, 10) : null,

    start_date: project.start_date || null,
    end_date: project.end_date || null,

    project_manager: project.project_manager,
    project_type: normalizedType,
    project_phase: normalizePhase(project.project_phase),

    target_site: project.target_site,
    site_readiness: project.site_readiness,

    skill_sets: project.skill_sets,
    transportation_requirements: project.transportation_requirements,
    utility_requirements: project.utility_requirements,
    infrastructure_requirements: infrastructureRequirements,
    retention_risks: project.retention_risks,
    support_needed: project.support_needed,

    property_owner: project.property_owner,

    current_employees:
      project.current_employees !== ""
        ? parseInt(project.current_employees, 10)
        : null,

    expected_new_hires:
      project.expected_new_hires !== ""
        ? parseInt(project.expected_new_hires, 10)
        : null,

    expansion_type: project.expansion_type || null,

    expansion_square_footage:
      project.expansion_square_footage !== ""
        ? parseInt(project.expansion_square_footage, 10)
        : null,

    reason_for_engagement: project.reason_for_engagement || null,

    square_footage:
      project.square_footage !== ""
        ? parseInt(project.square_footage, 10)
        : null,

    acreage: project.acreage !== "" ? parseFloat(project.acreage) : null,

    wage_rate: project.wage_rate !== "" ? parseFloat(project.wage_rate) : null,

    startup_stage: project.startup_stage || null,
    accelerator_program: project.accelerator_program || null,
    funding_source: project.funding_source || null,

    runway_months:
      project.runway_months !== ""
        ? parseInt(project.runway_months, 10)
        : null,
  };
}

export {
  PHASES,
  normalizePhase,
  mapApiTypeToUi,
  buildProjectPayload,
};
